
import { isWeb, getPlatform } from '../src/utils/platformUtils'

const dbName = 'myDB'


let SQLite = null
let __dbModule = null

try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { Platform } = require('react-native')
    if (Platform?.OS !== 'web') {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        SQLite = require('expo-sqlite')
    }
} catch {}

const buildLocalWrappedDb = () => {
    if (globalThis.__DOTS_SQLITE_WRAPPED_DB) {
        return globalThis.__DOTS_SQLITE_WRAPPED_DB
    }
    try {
        const localDb = SQLite.openDatabaseSync(dbName)
        if (getPlatform().OS === 'android') {
            try {
                localDb.execSync('PRAGMA journal_mode = WAL;')
            } catch {}
        }
        try {
            localDb.execSync('PRAGMA busy_timeout = 3000;')
        } catch {}
        const wrapStatement = (stmt) => ({
            executeSync: (params = []) => {
                const res = stmt.executeSync(params)
                const rowsArray = Array.isArray(res?.rows) ? res.rows : Array.isArray(res?.rows?._array) ? res.rows._array : []
                return {
                    ...res,
                    getAllSync: () => rowsArray,
                    getFirstSync: () => (rowsArray && rowsArray.length ? rowsArray[0] : null),
                }
            },
            finalizeSync: () => stmt.finalizeSync(),
        })
        const wrapped = {
            execSync: (sql) => localDb.execSync(sql),
            prepareSync: (sql) => {
                const stmt = localDb.prepareSync(sql)
                const wrapped = wrapStatement(stmt)
                return {
                    executeSync: wrapped.executeSync,
                    finalizeSync: wrapped.finalizeSync,
                    getAllSync: (params = []) => wrapped.executeSync(params).getAllSync(),
                    getFirstSync: (params = []) => wrapped.executeSync(params).getFirstSync(),
                }
            },
        }
        globalThis.__DOTS_SQLITE_WRAPPED_DB = wrapped
        return wrapped
    } catch (e) {
        console.error('Fallback SQLite wrapper (posts) failed:', e)
        return null
    }
}
const getWrappedDB = () => {
    if (!__dbModule) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        // __dbModule = require('../src/db/indexDB')
        __dbModule = require('../src/db/indexDB')
    }
    const fromIndex = __dbModule?.getNativeDB ? __dbModule.getNativeDB() : null
    return fromIndex || buildLocalWrappedDb()
}
const openDatabase = () => {
    if (isWeb()) {
        // Web: devolvemos façade mínima que no lanza errores
        return {
            transaction: (cb) => {
                const tx = { executeSql: (_s, _p, success) => success && success({}, { rows: { length: 0, item: () => null, _array: [] } }) }
                cb && cb(tx)
            },
            execSync: () => {},
            prepareSync: () => ({
                executeSync: () => ({ getAllSync: () => [], getFirstSync: () => null }),
                getAllSync: () => [],
                getFirstSync: () => null,
                finalizeSync: () => {},
            }),
        }
    }

    // TEMPORARY: Return a stub object with transaction method to prevent "db.transaction is not a function" errors
    // SQLite facade for legacy API compatibility
    const dbSync = getWrappedDB()

    const facade = {
        execSync: (sql) => dbSync.execSync(sql),
        prepareSync: (sql) => dbSync.prepareSync(sql),
        transaction: (callback, errorCallback, successCallback) => {
            try {
                const tx = {
                    executeSql: (sql, params = [], success, error) => {
                        try {
                            const isSelect = /^\s*SELECT/i.test(sql)
                            if (isSelect) {
                                const stmt = dbSync.prepareSync(sql)
                                const rowsArray = stmt.getAllSync(params)
                                stmt.finalizeSync()
                                const rows = {
                                    length: rowsArray.length,
                                    item: (i) => rowsArray[i],
                                    _array: rowsArray,
                                }
                                const result = { rows, rowsAffected: 0, insertId: undefined }
                                success && success(tx, result)
                            } else {
                                const stmt = dbSync.prepareSync(sql)
                                stmt.executeSync(params)
                                stmt.finalizeSync()
                                const changes = dbSync.prepareSync('SELECT changes() as rowsAffected').getFirstSync()
                                const lastId = /\bINSERT\b/i.test(sql)
                                    ? dbSync.prepareSync('SELECT last_insert_rowid() as insertId').getFirstSync()
                                    : { insertId: undefined }
                                const result = {
                                    rows: { length: 0, item: () => undefined, _array: [] },
                                    rowsAffected: changes?.rowsAffected ?? 0,
                                    insertId: lastId?.insertId,
                                }
                                success && success(tx, result)
                            }
                        } catch (e) {
                            if (error) return error(tx, e)
                            throw e
                        }
                    },
                }
                callback && callback(tx)
                successCallback && successCallback()
            } catch (e) {
                errorCallback && errorCallback(e)
            }
        },
    }

    return facade
}

export const database_next = openDatabase()